<!-- 注册/找回密码 -->
<template>
  <div class="register-components">
    <el-form class="form-container">
      <!-- 手机号 -->
      <el-form-item :class="{ 'el-form-item-error': !!phoneTip }">
        <el-input
          v-model="phone"
          class="form-control phone"
          placeholder="请输入手机号码"
          maxlength="11"
          @input="bindInputPhone"
        />
        <div class="el-form-item-error-tip" v-show="phoneTip">
          {{ phoneTip }}
        </div>
      </el-form-item>
      <!-- 验证码 -->
      <el-form-item :class="{ 'el-form-item-error': codeTip }">
        <div class="clearfix">
          <el-input
            v-model="code"
            class="form-control code"
            placeholder="请输入验证码"
            maxlength="4"
            @input="bindInputCode"
          />

          <el-button
            size="large"
            class="btn-send-code btn-primary"
            type="primary"
            id="send-code-button"
            :disabled="sending"
            @click.stop="sendCode"
          >
            {{ buttonText }}
          </el-button>
        </div>
        <div class="el-form-item-error-tip" v-show="codeTip">{{ codeTip }}</div>
      </el-form-item>
      <div id="captcha-element" v-show="needVerify"></div>
      <!-- 新密码 -->
      <el-form-item
        :class="{ 'el-form-item-error': !!passTip }"
        class="pass-form-item"
      >
        <el-input
          v-model="password"
          class="form-control"
          :placeholder="type === 'register' ? '设置密码' : '设置新密码'"
          maxlength="40"
          @input="bindInputPass"
          :type="passFlag ? 'password' : 'text'"
        />
        <img
          v-show="!passFlag"
          class="icon-view-tag"
          src="@/assets/img/login/icon-view-open.png"
          alt=""
          @click="passFlag = !passFlag"
        />
        <img
          v-show="passFlag"
          class="icon-view-tag"
          src="@/assets/img/login/icon-view-close.png"
          alt=""
          @click="passFlag = !passFlag"
        />
        <div class="el-form-item-error-tip pass-error-tips" v-show="passTip">
          {{ passTip }}
        </div>
        <div class="pass-tip">8-40个字符，必须包含数字、大写字母和小写字母</div>
      </el-form-item>
      <el-button
        size="large"
        formType="submit"
        class="submit btn-primary"
        type="primary"
        :loading="loading"
        @click.stop="formSubmit"
      >
        {{ type === "register" ? "注册并登录" : "重置密码并登录" }}
      </el-button>
    </el-form>
  </div>
</template>

<script>
import { vailPhone, vailPassWord } from "@/utils/utils";
import api from "@/plugins/api";
import loginHandle from "@/mixins/login-handle";

export default {
  name: "RegisterForm",
  mixins: [loginHandle],
  props: {
    // form标题
    type: {
      type: String,
      default: () => "register", //register:注册，reset-password：找回密码
    },
  },
  data() {
    return {
      code: "",
      codeTip: "",
      sending: false,
      buttonText: "获取验证码",
      time: 60,
      buttonTimer: null,
      loading: false,
      passFlag: true,
      needVerify: false,
      captchaInstance: null, // 阿里云3.0验证码实例
    };
  },
  beforeDestroy() {
    clearInterval(this.buttonTimer);
    // 清理验证码实例
    if (this.captchaInstance) {
      this.captchaInstance = null;
    }
  },
  methods: {
    formSubmit() {
      // 校验
      if (!this.phone) {
        this.phoneTip = "请填写手机号";
        return false;
      } else if (!vailPhone(this.phone)) {
        this.phoneTip = "手机号码格式错误";
        return false;
      } else if (!this.code) {
        this.codeTip = "请填写验证码";
        return false;
      } else if (this.code.length !== 4) {
        this.codeTip = "验证码错误";
        return false;
      } else if (!this.password) {
        this.passTip = "请填写密码";
        return false;
      } else if (!vailPassWord(this.password)) {
        this.passTip = "密码格式错误";
        return false;
      }
      this.fnRegister();
      return true;
    },
    bindInputCode() {
      this.code = this.code.replace(/\s+/g, "");
      if (this.code) {
        this.codeTip = "";
      }
    },
    sendCode(captchaVerifyParam = null) {
      // 校验phone
      if (this.phone) {
        if (!vailPhone(this.phone)) {
          this.phoneTip = "手机号码格式错误";
          return;
        }
      } else {
        this.phoneTip = "请填写手机号";
        return;
      }

      let params = {
        mobile: this.phone,
        scene: this.type,
      };
      if (this.type === "register") {
        params.need_check = 0;
      }

      // 如果有验证码参数，添加到请求中
      if (captchaVerifyParam) {
        params = { ...params, ...captchaVerifyParam };
      }

      this.sending = true;
      api.getSms(params).then((data) => {
        if (data.data.code === 1) {
          this.needVerify = false;
          this.eventGetCode();
          this.$message.success("验证码已发送");
          this.timer();
        } else {
          if (data.data.code === 30000) {
            this.needVerify = true;
            this.sending = false;
            this.$message.warning("需要图形验证码");
            // 延迟加载验证码，确保DOM已渲染
            this.$nextTick(() => {
              this.loadImage();
            });
            return false;
          }
          if (data.data.code === 30001) {
            this.sending = false;
            this.needVerify = true;
            this.$nextTick(() => {
              this.loadImage();
            });
            return false;
          }
          if (data.data.code === 30002) {
            this.needVerify = true;
            this.sending = false;
            this.$nextTick(() => {
              this.loadImage();
            });
            return false;
          }
          this.$message.error(data.data.msg);
          this.sending = false;
        }
        return true;
      });
    },
    timer() {
      this.buttonTimer = setInterval(() => {
        if (this.time < 1) {
          clearInterval(this.buttonTimer);
          this.buttonText = "获取验证码";
          this.sending = false;
          this.time = 60;
        } else {
          this.time = this.time - 1;
          this.buttonText = `${this.time}s后重新发送`;
        }
      }, 1000);
    },
    fnRegister() {
      this.loading = true;
      let params = {
        mobile: this.phone,
        password: this.password,
        mobile_code: this.code,
        auto_login: 1,
      };
      let fun = "";
      if (this.type === "register") {
        fun = "registerApi";
      } else {
        fun = "resetPassword";
      }
      api[fun](params)
        .then((data) => {
          this.loading = false;
          if (data.data.code === 1) {
            // 登录成功
            this.toPreRoute();
          } else {
            this.$message.error(data.data.message);
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 阿里云3.0图形验证码
    loadImage() {
      const _that = this;
      // 如果已经初始化过，先销毁
      if (_that.captchaInstance) {
        _that.captchaInstance = null;
      }

      // 使用阿里云3.0验证码初始化
      if (window.initAliyunCaptcha) {
        window.initAliyunCaptcha({
          // 场景ID。需要在阿里云验证码控制台获取
          SceneId: "8m32fbrj",
          // 验证码模式，popup表示弹出式，embed表示嵌入式
          mode: "embed",
          // 页面上预留的渲染验证码的元素
          element: "#captcha-element",
          button: "#send-code-button",
          // 验证码验证通过回调函数
          success: function (captchaVerifyParam) {
            const aliParam = {
              aliafs_token: captchaVerifyParam,
              aliafs_scene: "message",
            };

            // 验证成功后，调用发送短信接口
            _that.sendCode(aliParam);
            // 重置验证码状态
            _that.needVerify = false;
          },
          // 验证码验证不通过回调函数
          fail: function (result) {
            // 正常验证有效期内不需要做任何操作，验证码自动刷新，重新进行验证
            console.error("验证码验证失败:", result);
          },
          // 绑定验证码实例回调函数
          getInstance: function (instance) {
            _that.captchaInstance = instance;
          },
          // 滑块验证和一点即过的验证形态触发框体样式
          slideStyle: {
            width: 320,
            height: 40,
          },
          language: "cn",
        });
      } else {
        console.error("阿里云验证码SDK未加载");
        _that.$message.error("验证码加载失败，请刷新页面重试");
      }
    },
    eventGetCode() {},
    eventSignIn() {},
  },
};
</script>

<style lang="scss" src="./common.scss" scoped></style>
<style lang="scss" scoped>
$primary-color: #242424;
$white: #fff;
.register-components {
  .input-placeholder {
    font-size: 15px;
    font-weight: 400;
    color: rgba($primary-color, 0.24);
    line-height: 21px;
  }

  .submit {
    margin: 24px 0 20px;
    border-radius: 8px;
    width: 100%;
    background-color: $chiral-btn-color;
    font-size: 15px;
    line-height: 15px;
    font-weight: 500;
    color: $white;
    padding: 16px 0;
    height: 48px;
  }
  .clearfix {
    &::after {
      display: table;
      content: " ";
      clear: both;
    }
  }
  .form-control.code {
    float: left;
    width: calc(100% - 115px - 16px);
  }
  .verify {
    width: 64%;
    display: inline-block;
  }
  .verifypic {
    width: 100px;
    height: 40px;
    margin-left: 10px;
  }
  .btn-send-code {
    background-color: $chiral-btn-color;
    border-radius: 8px;
    font-size: 15px;
    line-height: 15px;
    font-weight: 400;
    color: $white;
    width: 115px;
    padding: 13px 0;
    float: right;
    height: 42px;
  }
  .pass-tip {
    font-size: 12px;
    font-weight: 400;
    color: #afafaf;
    line-height: 17px;
    padding-top: 4px;
  }
  .el-button--primary:focus,
  .el-button--primary:hover {
    background: $chiral-btn-color;
    border-color: $chiral-btn-color;
  }
  .el-button--primary.is-disabled,
  .el-button--primary.is-disabled:active,
  .el-button--primary.is-disabled:focus,
  .el-button--primary.is-disabled:hover {
    background: #cbcbcb;
    border-color: #cbcbcb;
  }
  .tips {
    color: #fd8216;
    font-size: 26px;
  }
  .checkerr {
    border-bottom: 2px solid #fd8216;
  }
  .el-form-item-error-tip {
    position: absolute;
    padding-left: 10px;
    padding-top: 4px;
    position: absolute;
    top: 100%;
    left: 0;
    line-height: 1;
    color: #ed4014;
  }
  .pass-form-item {
    position: relative;
  }
  .icon-view-tag {
    position: absolute;
    right: 16px;
    top: 8px;
    width: 24px;
    height: 24px;
    cursor: pointer;
  }
  .el-form-item-error-tip.pass-error-tips {
    position: static;
  }
}
</style>
<style lang="scss">
.register-components {
  .el-form-item-error input {
    border: 1px solid $error-color;
  }
}
</style>
